<template>
  <dl class="flex flex-wrap m-0 gap-x-8 gap-y-6">
    <slot></slot>
  </dl>
</template>
